import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClassEnrolment } from '../../../models/class-enrolment.model';

@Component({
    selector: 'app-administrative-work',
    templateUrl: './administrative-work.component.html',
    styleUrls: ['./administrative-work.component.scss'],
    standalone: false
})
export class AdministrativeWorkComponent { 
  enrolmentDto: ClassEnrolment;
  courseFee: boolean = false;
  adminWorkCompleted: boolean = false;
  eligibility: boolean = false;
  @Input() showEligibility = false;
  @Input() set Enrolment(v: ClassEnrolment) {
    this.enrolmentDto = v;
    this.courseFee = v.CourseFee ?? false;
    this.adminWorkCompleted = v.AdminWorkCompleted ?? false;
    this.eligibility = v.Eligibility ?? false;
  }

  @Input() isEditMode: boolean = false

  @Output() adminWorkUpdated = new EventEmitter<ClassEnrolment>();

  courseFeeChanged(val: boolean) {
    this.courseFee = val;
    this.enrolmentDto.CourseFee = val; 
    this.adminWorkUpdated.emit(this.enrolmentDto);
  }
  adminWorkCompletedChanged(val: boolean) {
    this.adminWorkCompleted = val; 
    this.enrolmentDto.AdminWorkCompleted = val;
    this.adminWorkUpdated.emit(this.enrolmentDto);
  }
  eligibilityChanged(val: boolean) {
    this.eligibility = val; 
    this.enrolmentDto.Eligibility = val;
    this.adminWorkUpdated.emit(this.enrolmentDto);
  }
}
